// extracted by mini-css-extract-plugin
module.exports = {"recardDrug":"recardDurg_recardDrug__2JupV","content":"recardDurg_content__KS59C","select":"recardDurg_select__3-f0E","total":"recardDurg_total__2IQyG"};